module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Consider generating the missing prices by clicking the button below.":"Die fehlenden Preise können per Klick auf die untere Schaltfläche generiert werden.","Generate missing customer group prices":"Fehlende Kundengruppenpreise generieren","Add price":"Preis hinzufügen"}}')
  delete Component.options._Ctor
}
